import simulationOneForm from "../modules/Utils/simulation_one_form";
import videoThumbGeral from "../modules/Utils/video_thumb_geral";

videoThumbGeral();

document.addEventListener('DOMContentLoaded', function() {
    // Initialize GLightbox for video modal
    if (typeof GLightbox !== 'undefined') {
        var videoLightbox = GLightbox({
            selector: '.glightbox',
            touchNavigation: true,
            loop: false,
            autoplayVideos: true
        });
    }

    let pageConsorcios = document.getElementById('consorcios');

    if ( pageConsorcios ) {
        const swiperStories = new Swiper('.swiper-types', {
            slidesPerView: 1,
            loop: false,
            spaceBetween: 42,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                    loop: false,
                },
                768: {
                    slidesPerView: 1.2,
                    spaceBetween: 30,
                    loop: false,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 42,
                    loop: false,
                },
            },
        });
    } else {
        // page consorcios detail
        // Note: Button toggling is now handled by simulation_one_form.js

        // swipers
        const swiperPlans = new Swiper('.swiper-plans', {
            slidesPerView: 3,
            loop: true,
            spaceBetween: 19,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: '.arrows-container .swiper-button-next',
                prevEl: '.arrows-container .swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                    loop: true,
                },
                768: {
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                    loop: true,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 19,
                    loop: true,
                },
            },
        });
    }
})

simulationOneForm();
